// import { createTheme } from '@mui/material/styles';
import { remCalc } from '../../utils/remCalc';
// import breakpoints from 'utils/breakpoints';

// const theme = createTheme({
// 	breakpoints: breakpoints,
// });

const styles = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
					'&.FullscreenVideo-root': {
						width: '100vw',
						height: '100vh',
						paddingLeft: 0,
						paddingRight: 0,
						video: {
							width: '100%',
							height: '100%',
						},
						'&.FullscreenVideo-hasChildren': {
							position: 'relative',
						},
						'&.FullscreenVideo-isPlaying': {
							'.FullscreenVideo-close': {
								opacity: 1,
							},
						},
					},

					'.FullscreenVideo-close': {
						fontWeight: 'bold',
						position: 'absolute',
						zIndex: 3,
						right: remCalc(50),
						cursor: 'pointer',
						opacity: 0,
						transition: 'all 300ms',
					},

					'.FullscreenVideo-children': {
						position: 'absolute',
						zIndex: 2,
						width: '100%',
						height: '100%',
						background: 'rgba(0, 0, 0, .8)',
						transition: 'all 300ms',

						'&.FullscreenVideo-childrenOpen': {
							opacity: 0,
						},
					},
				},
			},
		},
	},

}

export default styles;